// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import '@styles/webdesktop/webdesktop-style.scss';
import './GlobalDeclaration';
import './Extensions';
import './Commons/CanvasRenderingContext2D';
import './StaticResources';
import { App } from './Commons/Application';
import { logs } from './Controls/panels/FullLogsPanel';
//import { ShowWebAdminPanel } from '@front/controls/panels/WebAdminPanel';
import { Resources } from './Localizations/Resources';
import { wmh } from './Commons/UtilsClasses/WorkspaceManagerHelper';
export * from './ControlsImport';
export * from './Components/WebDesktop/RactiveImports';
export * from './ScreensImport';
// if (module.hot) {
//     module.hot.accept();
// }
window.addEventListener('load', function () {
    const me = document.getElementById('build_time');
    App.Initialize();
    window.ShowAllLocalizationKeys = (isShow) => {
        Resources.ShowAllLocalizationKeys(isShow);
    };
    window.logs = logs;
    //window.webadmin = ShowWebAdminPanel;
    window.wmh = wmh;
});
